export const isNarrow = (/** @type {string} */ orientation) =>
  ['LEFT_NARROW', 'RIGHT_NARROW'].includes(orientation);
